import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import axios from "axios";
import Loading from "./Loading";

const ProtectedRoute = ({ element: Element, requiredPermission }) => {
  const { user } = useAuthContext();
  const navigate = useNavigate()
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!user) {
        setIsAuthorized(false);
        setIsLoading(false);
        // console("AAAAAAAAAAAAAAA")
        return;
      }

      try {
        // console.log("BBBBBBBBBBBBBBBBBBB")
        const clubDetails = JSON.parse(localStorage.getItem("club_details"));
        if (!clubDetails?.club_id) {
          setIsAuthorized(false);
          setIsLoading(false);
          // console.log("CCCCCCCCCCCCCCCCCCCCC")
          return;
        }
        // console.log("DDDDDDDDDDDDDDDDDDD")
        // Get user roles for current club
        const rolesResponse = await axios.get(`/api/roles/user-roles`, {
          params: { userId: user.userId },
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "application/json",
          },
        });
        console.log(rolesResponse.request.status)

        const clubRoles = rolesResponse.data.filter(
          (role) => role.club_id == clubDetails.club_id
        );

        // console.log("EEEEEEEEEEEEEEEEEEEEEE: ", rolesResponse.data);

        // Get permissions for all roles
        const permissionsResponses = await Promise.all(
          clubRoles.map((role) =>
            axios.get(`/api/roles/role-permissions/${role.id}`, {
              headers: {
                Authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
              },
            })
          )
        );

        // console.log("FFFFFFFFFFFFFFFFFFFFF: ", permissionsResponses);

        // Combine all permissions
        const allPermissions = new Set();
        permissionsResponses.forEach((response) => {
          // console.log("FETCH PERMISSIONS: ", response.data);
          response.data.forEach((p) => allPermissions.add(p.permission));
        });

        // console.log("ALL PERMISSIONS: ", allPermissions);
        // console.log("REQUIRED PERMISSION: ", requiredPermission);
        setIsAuthorized(
          allPermissions.has(requiredPermission) || requiredPermission == ""
        );
      } catch (error) {
        // console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGG");
        console.error("Authorization check failed:", error);
        if (error.response.status == 401) {
          setIsAuthorized(false);
          localStorage.removeItem("club_admin");
          localStorage.removeItem("club_details");
          navigate("/login");
        }
      }
      
      setIsLoading(false);
    };

    checkAuthorization();
  }, [user, requiredPermission]);

  if (isLoading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAuthorized && user.role != "club_manager") {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Element />;
};

export default ProtectedRoute;